import React from 'react';
import './Investors.css';

const investorLogos = [
  "https://sendbird.imgix.net/cms/Frame-1000008902_2025-01-24-125955_hlhi.png", "https://sendbird.imgix.net/cms/2_2025-01-24-131944_fcdl.png", "https://sendbird.imgix.net/cms/3_2025-01-24-131953_pcwt.png", "https://sendbird.imgix.net/cms/4_2025-01-24-132000_bcwg.png", "https://sendbird.imgix.net/cms/5_2025-01-24-132024_kqju.png", "https://sendbird.imgix.net/cms/6_2025-01-24-132036_bndk.png", "https://sendbird.imgix.net/cms/7_2025-01-24-132118_dqjh.png", "https://sendbird.imgix.net/cms/8_2025-01-24-132125_bseb.png", "https://sendbird.imgix.net/cms/9_2025-01-24-132132_xxwn.png", "https://sendbird.imgix.net/cms/91.png", "https://sendbird.imgix.net/cms/92.png", "https://sendbird.imgix.net/cms/93.png"
];

function Investors() {
  return (
    <section className="investors-section container">
      <h3 className="investors-main-title">Our investors</h3>
      <div className="investors-grid">
        {investorLogos.map((logo, index) => (
          <div key={index} className="investor-logo-container">
            <img src={logo} alt={`Investor logo ${index + 1}`} className="investor-logo" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Investors;